import React, { useState } from "react";
import { BoltingData } from "../../apis/types";
import ClassificationMenu from "../../components/ClassificationMenu/ClassificationMenu";
import { useAppDispatch } from "../../store/hooks";
import { setFeedbackClassification } from "../../store/labellingSlice";

interface ClassificationFeedbackComponentInput {
  row: BoltingData;
  updateSelectedRow: (row: BoltingData) => void;
}

export const ClassificationFeedbackComponent: React.FC<
  ClassificationFeedbackComponentInput
> = props => {
  const [selectedClassification, setSelectedClassification] = useState<string>("-");

  const dispatch = useAppDispatch();



  React.useEffect(() => {
    setSelectedClassification(props.row.classification || "-");
    dispatch(setFeedbackClassification(props.row.classification || "-"));
  }, [props.row.classification]);

  const handleDropdownChange = (classification: string) => {
    setSelectedClassification(classification);
    dispatch(setFeedbackClassification(classification));
  };

  return (
    <div>
      <ClassificationMenu
        selectedClassification={selectedClassification}
        onClassificationChange={handleDropdownChange}
      />
    </div>
  );
};

export default ClassificationFeedbackComponent;
